// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 64,
  H_DESKTOP: 80,
  H_DESKTOP_OFFSET: 80 - 16,
};

export interface CookieBannerHeights {
  DESKTOP: string;
  MOBILE: string;
}

export const COOKIE_BANNER = { DESKTOP: '220px', MOBILE: '350px' };

export const BANNER_HEIGHT = {
  H_MOBILE: 64,
  H_DESKTOP: 40,
  H_DESKTOP_OFFSET: 40 - 16,
};

export const EDIT_ORDER_BANNER_HEIGHT = 46;

export const NAV = {
  W_VERTICAL: 220,
  W_MINI: 88,
};
